import { createUrl } from "./urlQueryHelper.js";

export function saveDataListState(page, rowsPerPage, dataListFilter) {
  if (!history.pushState) {
    return;
  }
  const newurl = createUrl(page, rowsPerPage, dataListFilter);
  window.history.pushState({ path: newurl }, "", newurl);
}